import { OnInit, ElementRef, Renderer2 } from '@angular/core';
var ColumnGroupComponent = /** @class */ (function () {
    function ColumnGroupComponent(renderer, element) {
        this.renderer = renderer;
        this.element = element;
        this._isActive = false;
    }
    Object.defineProperty(ColumnGroupComponent.prototype, "isActive", {
        get: function () {
            return this._isActive;
        },
        set: function (value) {
            this._isActive = value;
            this.show(this.isActive);
        },
        enumerable: true,
        configurable: true
    });
    ColumnGroupComponent.prototype.ngOnInit = function () {
    };
    ColumnGroupComponent.prototype.show = function (show) {
        var style = this.isActive ? 'flex' : 'none';
        // const this.sanitizer.bypassSecurityTrustStyle(style);
        this.renderer.setStyle(this.element.nativeElement, 'display', style);
    };
    return ColumnGroupComponent;
}());
export { ColumnGroupComponent };
